import React from 'react'

import SelectableClient from '../SelectableClient'

const Client = ({ client, onClick }) => {
  return <SelectableClient client={client} onClick={onClick} />
}

export default Client
